<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-12">
            <span translate="Settings.OrganisationBrandingSection.PrivateWhatsAppAccount"></span>
        </h3>
    </div>

    <div class="p-4 pt-0">
        <form [formGroup]="form" (ngSubmit)="savePrivateWhatsapp()">
            <div class="mb-5">
                <label for="whatsapp" class="form-label" translate="Settings.OrganisationBrandingSection.WhatsAppForBusiness"></label>
                <input type="text" id="whatsapp" class="form-control" formControlName="whatsapp" [(ngModel)]="whatsappNumber" maxlength="15" required placeholder="{{'Settings.OrganisationBrandingSection.EnterPhoneNumber' | translate}}">
            </div>
    
            <div class="col-12 mt-5 pb-2 d-table w-100">
                <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="back()" translate="Button.Back"></button></span>
                <span class="float-end"><button type="submit" id="buttonSave" class="btn btn-sm btn-primary" [disabled]="!form.valid" translate="Button.SaveChanges"></button></span>
            </div>
        </form>
    </div>
</div>
